<template>
  <b-row v-if="isXsSm && items.length">
    <b-col>
      <v-select
        ref="select__filter_status"
        v-model="$_vModel"
        :options="items"
        :reduce="(option) => option.value"
        :clearable="false"
        :searchable="false"
        name="select__filter_status"
        @option:selected="onSelectStatus"
      >
        <template slot="option" slot-scope="option">
          <div class="d-flex justify-content-between py-2">
            <div class="d-flex">
              <img
                :src="
                  require(`../../assets/icon-status-submission/${
                    templateStats[option.ref].icon
                  }.png`)
                "
                alt=""
                width="22px"
                height="22px"
              />
              <div
                class="text__status ml-2"
                :class="{
                  [`text__status__${templateStats[option.ref].className}`]:
                    $_vModel === templateStats[option.ref].value
                }"
              >
                {{ templateStats[option.ref].status }}
              </div>
            </div>
            <b
              :class="{
                [`text__status__${templateStats[option.ref].className}`]:
                  $_vModel === templateStats[option.ref].value
              }"
              >{{ templateStats[option.ref].counts }}</b
            >
          </div>
        </template>

        <template slot="selected-option" slot-scope="option">
          <div class="d-flex py-2">
            <img
              :src="
                require(`../../assets/icon-status-submission/${templateStats[option.ref].icon}.png`)
              "
              alt=""
              width="22px"
              height="22px"
            />
            <div
              class="text__status ml-2"
              :class="{
                [`text__status__${templateStats[option.ref].className}`]:
                  $_vModel === templateStats[option.ref].value
              }"
            >
              {{ templateStats[option.ref].status }}
              <b class="ml-2">{{ templateStats[option.ref].counts }}</b>
            </div>
          </div>
        </template>
      </v-select>
    </b-col>
  </b-row>

  <b-row v-else-if="items.length" class="w-100 m-0">
    <b-col
      v-for="(value, index) in items"
      :key="index"
      align-self="stretch"
      class="d-flex justify-content-center px-0 mx-auto"
      style="cursor: pointer"
      @click="onClick(value)"
    >
      <div
        :ref="[`button__filter_status_${templateStats[value.ref].className}`]"
        class="card card-box w-100"
        :name="[`button__filter_status_${templateStats[value.ref].className}`]"
        :class="{
          [`active__${templateStats[value.ref].className}`]:
            $_vModel === templateStats[value.ref].value
        }"
        style="max-width: 188px"
      >
        <div class="card-body px-0" style="min-height: 132px">
          <div class="text-center">
            <img
              :src="
                require(`../../assets/icon-status-submission/${templateStats[value.ref].icon}.png`)
              "
              alt=""
            />

            <div class="mt-3 line-height-sm">
              <div class="mb-1 text_status-count">
                <b>{{ templateStats[value.ref].counts }}</b>
              </div>
              <div class="text__status">
                {{ templateStats[value.ref].status }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { amplitudeMixin } from '@/mixins/amplitudeMixin';
import EvidenceSubmission from '@/models/EvidenceSubmission';
import LearningUnitSubmissionStat from '@/models/LearningUnitSubmissionStat';
import { debounce } from 'lodash';
const breakpointAtMedium = 576;

export default {
  mixins: [amplitudeMixin],

  model: {
    prop: 'vModel',
    event: 'change'
  },

  props: {
    learningUnitId: {
      type: Number,
      default: null
    },

    vModel: {
      type: String,
      default: 'All',
      required: true
    },

    static: {
      type: Boolean,
      default: false
    },

    staticStats: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      windowSize: null,
      items: [],
      templateStats: {
        total_submissions: {
          status: 'All',
          value: 'ALL',
          className: 'all',
          icon: 'icon-status-all',
          counts: 0
        },
        total_not_submitted: {
          status: EvidenceSubmission.STATUS.NOT_SUBMITTED,
          value: 'NOT_SUBMITTED',
          className: 'not_submitted',
          icon: 'icon-status-not-submitted',
          counts: 0
        },
        total_review_pending: {
          status: EvidenceSubmission.STATUS.REVIEW_PENDING,
          value: 'REVIEW_PENDING',
          className: 'review_pending',
          icon: 'icon-status-review-pending',
          counts: 0
        },
        total_in_progress_by_assessor: {
          status: EvidenceSubmission.STATUS.IN_PROGRESS_BY_ASSESSOR,
          value: 'IN_PROGRESS_BY_ASSESSOR',
          className: 'in_progress_by_assessor',
          icon: 'icon-status-in-progress-assessor',
          counts: 0
        },
        total_in_progress_by_issuer: {
          status: EvidenceSubmission.STATUS.IN_PROGRESS_BY_ISSUER,
          value: 'IN_PROGRESS_BY_ISSUER',
          className: 'in_progress_by_issuer',
          icon: 'icon-status-in-progress-issuer',
          counts: 0
        },
        total_achieved: {
          status: EvidenceSubmission.STATUS.ACHIEVED,
          value: 'AWARDED',
          className: 'achieved',
          icon: 'icon-status-achieved',
          counts: 0
        },
        total_awarded: {
          status: EvidenceSubmission.STATUS.AWARDED,
          value: 'AWARDED',
          className: 'awarded',
          icon: 'icon-status-awarded',
          counts: 0
        },
        total_denied: {
          status: EvidenceSubmission.STATUS.DENIED,
          value: 'DENIED',
          className: 'denied',
          icon: 'icon-status-denied',
          counts: 0
        }
      }
    };
  },

  computed: {
    $_vModel: {
      get() {
        return this.vModel;
      },

      set(v) {
        this.$emit('change', v);
      }
    },

    isXsSm() {
      return this.windowSize < breakpointAtMedium;
    },

    windowHeight() {
      return this.isXsSm ? `${window.innerHeight + window.outerHeight}%` : '100%';
    }
  },

  watch: {
    staticStats: 'updateStat'
  },

  created() {
    this.fetchSubmissionStats = debounce(this.fetchSubmissionStats, 500);
  },

  mounted() {
    this.registerWindowSizeObserver();

    this.init();
  },

  methods: {
    init() {
      if (this.static) {
        this.handleStaticStats();
      } else {
        this.fetchSubmissionStats();
      }
    },

    async handleStaticStats() {
      if (!this.static) return;

      this.updateStat(this.staticStats);
    },

    async fetchSubmissionStats() {
      if (this.static) return;

      let params = {};

      if (this.learningUnitId) {
        params['learningUnitId'] = this.learningUnitId;
      }

      const {
        response: { data = {} }
      } = await LearningUnitSubmissionStat.api().fetch(params);

      if (
        Object.keys(data).length &&
        Object.hasOwnProperty.call(data, 'total_submissions') &&
        Object.hasOwnProperty.call(data, 'total_not_submitted')
      ) {
        data['total_submissions'] = data['total_submissions'] - data['total_not_submitted'];

        delete data['total_not_submitted'];
      }

      this.updateStat(data);
    },

    updateStat(obj) {
      let items = [];
      for (const key in obj) {
        if (obj.hasOwnProperty.call(obj, key) && obj.hasOwnProperty.call(this.templateStats, key)) {
          let countSubmission = obj[key];

          this.templateStats[key].counts = countSubmission;

          items.push({
            label: this.templateStats[key].status,
            value: this.templateStats[key].value,
            ref: key
          });
        }
      }

      this.items = [...items];
    },

    onClick({ ref = '' }) {
      const target = this.$refs[`button__filter_status_${this.templateStats[ref].className}`]
        ? this.$refs[`button__filter_status_${this.templateStats[ref].className}`][0]
        : null;
      this.$_amplitudeMixin_onChange(target, {
        Type: 'select',
        Name: 'occupation',
        Value: this.templateStats[ref].status
      });
      return this.$emit('change', this.templateStats[ref].value);
    },

    onSelectStatus({ ref = '' }) {
      const target =
        this.$refs['select__filter_status'] && this.$refs['select__filter_status'].$el
          ? this.$refs['select__filter_status'].$el
          : null;
      this.$_amplitudeMixin_onChange(target, {
        Type: 'select',
        Name: 'occupation',
        Value: this.templateStats[ref].status
      });
      this.$emit('change', this.templateStats[ref].value);
    },

    updateWindowSize(entries) {
      const [entry] = entries;
      this.windowSize = entry.contentRect.width;
    },

    registerWindowSizeObserver() {
      const callback = debounce(this.updateWindowSize, 100);

      const body = document.querySelector('body');
      const resizeObserver = new ResizeObserver(callback);

      resizeObserver.observe(body);
    }
  }
};
</script>

<style lang="scss" scoped>
$all: #3c44b1;
$background-all: #eceef7;
$not_submiited: #7a7b97;
$review_pending: #f4772e;
$background-review_pending: #fffbf2;
$background-not_submiited: #eceef7;
$in_progress_by_assessor: #11c5db;
$background-in_progress_by_assessor: #e8fbfd;
$in_progress_by_issuer: #f4772e;
$background-in_progress_by_issuer: #fffbf2;
$awarded: #1bc943;
$background-awarded: #e5f9ed;
$achieved: #1bc943;
$background-achieved: #e5f9ed;
$denied: #f83245;
$background-denied: #fff5f6;

.card {
  box-shadow: none !important;
}

.card-box {
  border-width: 1px 1px 4px 1px;
  border-color: transparent;
}

.text__status {
  color: rgba(7, 9, 25, 0.5);

  &__all {
    color: $all !important;
  }

  &__not_submitted {
    color: $not_submiited !important;
  }

  &__review_pending {
    color: $review_pending !important;
  }

  &__in_progress_by_assessor {
    color: $in_progress_by_assessor !important;
  }

  &__in_progress_by_issuer {
    color: $in_progress_by_issuer !important;
  }

  &__awarded {
    color: $awarded !important;
  }

  &__achieved {
    color: $achieved !important;
  }

  &__denied {
    color: $denied !important;
  }
}

.active {
  &__all {
    color: $all !important;
    border-bottom-color: $all !important;
    background-color: $background-all !important;

    .text__status {
      color: $all !important;
    }
  }

  &__not_submitted {
    color: $not_submiited !important;
    border-bottom-color: $not_submiited !important;
    background-color: $background-not_submiited !important;

    .text__status {
      color: $not_submiited !important;
    }
  }

  &__review_pending {
    color: $review_pending !important;
    border-bottom-color: $review_pending !important;
    background-color: $background-review_pending !important;

    .text__status {
      color: $review_pending !important;
    }
  }

  &__in_progress_by_assessor {
    color: $in_progress_by_assessor !important;
    border-bottom-color: $in_progress_by_assessor !important;
    background-color: $background-in_progress_by_assessor !important;

    .text__status {
      color: $in_progress_by_assessor !important;
    }
  }

  &__in_progress_by_issuer {
    color: $in_progress_by_issuer !important;
    border-bottom-color: $in_progress_by_issuer !important;
    background-color: $background-in_progress_by_issuer !important;

    .text__status {
      color: $in_progress_by_issuer !important;
    }
  }

  &__awarded {
    color: $awarded !important;
    border-bottom-color: $awarded !important;
    background-color: $background-awarded !important;

    .text__status {
      color: $awarded !important;
    }
  }

  &__achieved {
    color: $achieved !important;
    border-bottom-color: $achieved !important;
    background-color: $background-achieved !important;

    .text__status {
      color: $achieved !important;
    }
  }

  &__denied {
    color: $denied !important;
    border-bottom-color: $denied !important;
    background-color: $background-denied !important;

    .text__status {
      color: $denied !important;
    }
  }
}

::v-deep .vs__dropdown-toggle {
  padding: 0 10px 4px 10px;
}
</style>
